import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styles: []
})
export class LoadingComponent implements OnInit {

 constructor(public loaderService: LoaderService) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/loading/loading.component.ts